import { render, staticRenderFns } from "./ChannelCommission.vue?vue&type=template&id=d7ef249e&scoped=true&"
import script from "./ChannelCommission.vue?vue&type=script&lang=js&"
export * from "./ChannelCommission.vue?vue&type=script&lang=js&"
import style0 from "./ChannelCommission.vue?vue&type=style&index=0&id=d7ef249e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7ef249e",
  null
  
)

export default component.exports